import React from 'react'
import axios from 'axios'
import { get } from 'lodash'

import userStore from '~/redux/user/store'
import { login, fbLogin, googleLogin, signup, getCardInfo } from '~/redux/user/actions'

import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'

import popup from '../../popup'
import socialHelpers from '../socialHelpers'

import './login.css'

export default class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      activeTab: this.props.activeTab ? this.props.activeTab : 'login',
      emailConsent: {},
      emailChecked: null
    }

    this.toggleEmailCheck = this.toggleEmailCheck.bind(this)
  }

  componentDidMount() {
    if (this.initializedSocialLogin) return
    this.initializedSocialLogin = true
    socialHelpers.initializeFacebookLogin()
    if (get(window.settings, 'socialMedia.googlePlus.signin')) {
      socialHelpers.initializeGoogleLogin(this.googleButtonEl, this.googleLoginCallback.bind(this))
    }
    this.fetchEmailConsent()

    const { pathname, search } = window.location
    const args = search.slice(1).split('&').map(v => v.split('=')).reduce((map, [key, value]) => map.set(key, decodeURIComponent(value)), new Map())
    if (pathname === '/sign-up' || args.get('signup') === 'true')  {
      this.setState({ activeTab: 'signup' })
      this.emailInput.value = args.get('email') || ''
    }
  }

  fetchEmailConsent() {
    let emailConsentUrl = `https://d2tipiv4cs5bo1.cloudfront.net/emailconsent/${window.settings.internalName}.json`;
    return axios.get(emailConsentUrl).then( r => {
      let emailConsentConfig = r.data
      return getCountryCode().then( countryCode => {
        let config = emailConsentConfig[countryCode] || emailConsentConfig.default || {}
        this.setState({
          emailConsent: config, 
          emailChecked: config.checked
        }) 
      })
    }).catch( e => {
      return 
    })
  }
  
  renderEmailConsent() {
    const { emailConsent, emailChecked } = this.state
    if (!emailConsent.visible)
      return 
    
    return (
      <div className="email-consent">
        <input onChange={this.toggleEmailCheck} type="checkbox" checked={emailChecked}/>
        <div className="copy" dangerouslySetInnerHTML={{__html: emailConsent.copy}}></div>
      </div>
    )
  }

  toggleEmailCheck(e) {
    this.setState({
      emailChecked: e.target.checked
    })
  }

  shouldDisableLogin() {
    if (this.state.buttonProgress)
      return true

    return false
    // if (this.state.activeTab === 'login')
    //   return false
    // if (!this.state.emailConsent.visible)
    //   return false

    // return !this.state.emailChecked
  }


  render() {
    const shouldDisableLogin = this.shouldDisableLogin()
    const isSVOD = window.settings.serviceType === 'SVOD'

    return (
      <div className="auth-view centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <form
          className="login-view"
          onSubmit={ evt => {
            evt.preventDefault()
            this.state.activeTab === 'login' ? this.logIn() : this.signUp()
          } }>
          <div className="tab-buttons">
            <div
              className={ `login-tab-button tab-button ${ this.state.activeTab === 'login' ? 'active' : '' }` }
              onClick={ evt => { this.setState({ activeTab: 'login' }) } }
            > 
              <span className="site-border-color">Log In</span>
            </div>
            <div
              className={ `signup-tab-button tab-button ${ this.state.activeTab === 'signup' ? 'active' : '' }` }
              onClick={ evt => { this.props.hardwall ? popup.createSubscription() : this.setState({ activeTab: 'signup' }) } }
              > <span className="site-border-color">{isSVOD ? 'Subscribe Now' : 'Sign Up'}</span> </div>
          </div>
          <div>
            <div className="input-box">
              <input  
                type="email" 
                placeholder="ENTER YOUR EMAIL" 
                ref={ i => { this.emailInput = i} }  
                onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } } 
                autoFocus 
                required                
              />
            </div>
            <div className={ `input-box collapsible ${this.state.activeTab === 'login' ? 'collapsed': ''}` }>
              { this.state.activeTab !== 'login' && (
                <input 
                  placeholder="ENTER YOUR NAME" 
                  ref={ i => { this.nameInput = i} } 
                  onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } } 
                  required
                />
              ) }
            </div>
            <div className="input-box">
              <input
                placeholder={`${this.state.activeTab === 'login' ? 'ENTER YOUR' : 'CREATE YOUR'} PASSWORD`}
                ref={ i => { this.passwordInput = i} }
                type="password"
                onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } }
                onKeyUp={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } }
                onKeyPress={ e => {
                  if (e.key === 'Enter') { this.state.activeTab === 'login' ? this.logIn() : this.signUp() }
                } }
                required/>
            </div>
            { this.state.activeTab === 'signup' &&
              this.renderEmailConsent() 
            }
          </div>
          <div className={ `error-box collapsible ${ this.state.error ? '' : 'collapsed' }` }>
            { this.state.error || '' }
          </div>
          <div>
            <input
              type="submit"
              className={`login-button button fat cta ${ shouldDisableLogin ? 'disabled' : '' }`}
              value={
                this.state.activeTab === 'login' ?
                  (this.state.buttonProgress ? 'Logging In ...' : 'Log In') :
                  (this.state.buttonProgress ? (isSVOD? 'Subscribing ...' : 'Signing Up ...' ) : isSVOD? 'Subscribe Now' : 'Sign Up')
              } />
            <div
              className="forgot-password-button fat"
              onClick={ _ => { popup.forgotPassword(this.props.hardwall) } }>
                Forgot Password?
              </div>
          </div>
          
        </form>

        <div className="or">
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="text">Or</div>
        </div>
        <div className="social-logins">
          <div className="social-buttons">
            <button 
              disabled={shouldDisableLogin} 
              className="facebook-color-background button fat" 
              onClick={ e => this.facebookLogin(e) }
            >
              { this.state.activeTab === 'login' ? 'Log In' : 'Sign Up' } With Facebook
            </button><br />
            { get(window.settings, 'socialMedia.googlePlus.signin') && 
              <button 
                disabled={shouldDisableLogin} 
                className="google-color-background button fat" 
                ref={ el => this.googleButtonEl = el }
              >
                { this.state.activeTab === 'login' ? 'Log In' : 'Sign Up' } With Google
              </button> 
            }
          </div>
        </div>
        { this.state.activeTab === 'signup' && window.settings.features.legal_verbiage &&
            <div className="ageCheck">
              {this.state.ageCheckError && !this.state.ageIsChecked && <div className="ageCheckError">{this.state.ageCheckError}</div>}
              <input type="checkbox"  checked={this.state.ageIsChecked} id="ageCheck" onClick={() => this.setState({ageIsChecked:!this.state.ageIsChecked, ageCheckError:null})}/><span>{window.settings.features.legal_verbiage_copy}</span>
            </div>
          }
      </div>
    )
  }

  socialLogins() {
    return (
      <div>
      </div>
    )
  }

  facebookLogin(e) {
    const element = document.getElementById('ageCheck')
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }

    window.FB.login( res => {
      var accessToken = res && res.authResponse && res.authResponse.accessToken
      if (!accessToken)
        return this.alert('Facebook login failed')
      this.dispatchLogin(fbLogin({
        facebookToken: accessToken,
        emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
      }), 'Facebook')
    }, { scope: 'email,public_profile' })
  }

  googleLoginCallback(error, googleUser) {
    if (error)
      return this.alert('Google login failed')
    var accessToken = googleUser.getAuthResponse().id_token;
    this.dispatchLogin(googleLogin({
      googleToken: accessToken,
      emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
    }), 'Google')
  }

  logIn() {
    if (this.state.buttonProgress)
      return
      
    this.setState({buttonProgress: true })

    var creds = {
      email: this.emailInput.value,
      password: this.passwordInput.value
    }

    this.dispatchLogin(login(creds), 'Native')
  }

  dispatchLogin(act, loginType) {
    if(this.props.onInitiate){ this.props.onInitiate('login') }
    userStore
      .dispatch(act)
      .then( _ => {
        var userInfo = userStore.getState().user || {}
        userInfo && addUserProfile("Site", {
          Name: userInfo.name,
          Email: userInfo.email,
          Identity: userInfo.userId,
          "User Status": userInfo.isSubscribed
            ? "Subscribed"
            : "Registered and Never Subscribed"
        });
        
        trackEvent('Login', {platform: 'Web', registrationType: loginType})
        userStore
          .dispatch(getCardInfo(userInfo))
          .then(res => {
            if (this.props.onAuthenticate) {
              this.props.onAuthenticate(true)
              return false
            } else if (!_.value.isSubscribed && window.settings.serviceType === "SVOD") {
              window.location.href = "/viewplans";
              return false;
            }
          });
     
        this.setState({ buttonProgress: false })
        popup.hide()
      })
      .catch( error => {
        console.log(error)
        this.setState({ buttonProgress: false })

        var message = (((error || {}).response || {}).data || {}).error || "There was an error processing your request.";
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
  }

  signUp() {
    const element = document.getElementById('ageCheck')
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }

    if (this.state.buttonProgress)
      return

    this.setState({buttonProgress: true, error: '' })

    var user = {
      name: this.nameInput.value,
      email: this.emailInput.value,
      password: this.passwordInput.value,
      emailConsent: this.state.emailConsent.visible ? this.state.emailChecked : undefined
    }

    if(this.props.onInitiate){ this.props.onInitiate('signup') }
    userStore
      .dispatch(signup(user))
      .then( _ => {
        var userInfo = this.props.user
        userInfo && addUserProfile('Site', {
          'Name': userInfo.name,
          'Email': userInfo.email,
          'Identity': userInfo.userId,
          'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
        })
        trackEvent('Signed Up', {registrationType: 'Native'})
        if(this.props.onAuthenticate){ 
          this.props.onAuthenticate(true) 
          return false
        } else if(!_.value.isSubscribed && window.settings.serviceType === "SVOD" && !window.settings.forceLogin){
          window.location.href="/viewplans";
          return false;
        }
        this.setState({ buttonProgress: false })
        popup.hide()
        console.log('Done signing up');
      })
      .catch(error => {
        this.setState({ buttonProgress: false })
        var message =
          (((error || {}).response || {}).data || {}).error ||
          'There was an error processing your request.'
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
  }

  checkPwdValid(e){
    if(!this.passwordInput)
      return
    
    let password = this.passwordInput.value;
    const atPassword = e.currentTarget.type.indexOf('password') !== -1
    const errorTextBox = document.getElementsByClassName('error-box')
    errorTextBox[0].classList.remove('collapsed')
    if ((password.length < 5 || password.length > 50) && atPassword ){
      errorTextBox[0].textContent = 'Password should be between 5 and 50 characters'
      return false;
    }
    errorTextBox[0].textContent= ''
    errorTextBox[0].classList.add('collapsed')
    if(!atPassword) {
      errorTextBox[0].classList.add('collapsed')
    }
  }

  alert(txt) {
    this.setState({ error: txt })
  }
}